import {
  UserKeys,
  getGmailDeletionModels,
  idAccessToken,
} from '../../../api/users-api';
import GmailDeletionGrid from './gmail-deletion-grid';
import { pagesConfig } from '../../../shared/pages-config';
import { useQuery } from '@tanstack/react-query';
import { Messages } from '../../../utils/message-constants';
import { useUserSettings } from '../../../utils/use-user-settings';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../shared/analytics/module-list';
import { Outlet } from 'react-router-dom';
import { useRouteMatch } from '../../../shared/useRouteMatch';

export default function GmailDeletionPage() {
  const { toolsRoles, changeLogRoles, loggedInUser } = useUserSettings();

  const {
    data: gmailDeletionModels,
    isLoading: gmailDeletionLoading,
    isFetching: gmailDeletionFetching,
  } = useQuery({
    queryKey: [UserKeys.GmailDeletionModels],
    queryFn: () => getGmailDeletionModels(),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('gmail deletion models'),
    },
  });

  const { data: accessToken } = useQuery({
    queryKey: [UserKeys.AccessToken],
    queryFn: () => idAccessToken(),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('the access token'),
    },
  });

  const isFormPage = useRouteMatch([
    `${pagesConfig.gmailDeletion.link}/${pagesConfig.createGmailDeletionFormPage.link}`,
    `${pagesConfig.gmailDeletion.link}/${pagesConfig.editGmailDeletionFormPage.link}`,
  ]);
  if (isFormPage) return <Outlet />;

  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.importExport.name },
        { label: pagesConfig.gmailDeletion.name },
      ]}
      bookmarkKey={pagesConfig.gmailDeletion.value}
    >
      <GmailDeletionGrid
        gmailDeletionModels={gmailDeletionModels || []}
        isLoading={gmailDeletionLoading}
        isFetching={gmailDeletionFetching}
        toolsRoles={toolsRoles}
        changeLogRoles={changeLogRoles}
        loggedInUser={loggedInUser}
        accessToken={accessToken!}
      />
    </SimpleBreadcrumbsPage>
  );
}
